import { useEffect, useState, useRef } from 'react'
import { createPortal } from 'react-dom'

export default function ClientOnly ({ children, ...delegated }) {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) {
    return null
  }

  return <div {...delegated}>{children}</div>
}

export function ClientOnlyPortal ({ children, selector }) {
  const ref = useRef()
  const [, forceUpdate] = useState({})

  useEffect(() => {
    ref.current = document.querySelector(selector)
    forceUpdate({})
  }, [selector])

  return ref.current ? createPortal(children, ref.current) : null
}
